import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faUpload, faCalendarDay, faChessRook } from '@fortawesome/free-solid-svg-icons'
import Username from '../common/Username';
import Moment from 'react-moment';

const ScreenshotsItem = (props) => (
    <div className="panel-adt">
        <Zoom
            overlayBgColorStart='rgba(0, 0, 0, 0.7)'
            overlayBgColorEnd='rgba(0, 0, 0, 0.7)'
            zoomMargin={40}
        >
         <img
            src={props.screenshot.image}
            alt={props.screenshot.title}
            className='adt-gallery-image'
            /> 
        </Zoom>
        <div>
            <h5>{props.screenshot.title}</h5>
            <div><FontAwesomeIcon className="text-primary" icon={faEye} fixedWidth /> {props.screenshot.views}</div>
            <div><FontAwesomeIcon className="text-primary" icon={faChessRook} fixedWidth /> {props.chapters[props.screenshot.chapter].game.title}</div>
            <div><FontAwesomeIcon className="text-primary" icon={faCalendarDay} fixedWidth /> <Moment format="MMM D YYYY h:mm A">{props.screenshot.created}</Moment></div>
            <div><FontAwesomeIcon className="text-primary" icon={faUpload} fixedWidth /> <Username user={props.users[props.screenshot.poster]} rank={props.users[props.screenshot.poster].rank} /></div>
        </div>
    </div>
);


export default ScreenshotsItem;


// WEBPACK FOOTER //
// ./src/Media/ScreenshotsItem.js